<header class="header">
  <h1 class="header__title" translate="verification.routing.full"></h1>
  <btn
    [link]="true"
    (action)="promptSkip()"
    buttonText="common.btn.later"
    class="header__skip"
    data-e2e-element="verify-later.button"
  ></btn>
</header>
<div
  *ngIf="isRejected$ | async"
  class="notification alert-warning"
  data-e2e-element="identity.status.rejected"
>
  <span class="c-red" translate="profile-identity.status.rejected"></span>
  <div><span translate="profile-identity.label.reason"></span>&nbsp;<span [innerHTML]="rejectReason$ | async"></span></div>
</div>

<div class="sumsub-placeholder"></div>
